
/**
 * Funkcja pozwalająca na wpisanie tylko liter od a do ż (z polskimi znakami) 
 * oraz poprawiająca pierwszą literę danego słowa na wielką
*/
export const onlyChars = (valueToParse: string): string => {
   const firstLetterCapitalized = valueToParse.charAt(0).toUpperCase() + valueToParse.slice(1)
   return firstLetterCapitalized.replace(/[^a-żA-Ż\s-]*/g, "");
}

export const onlyNumbers = (valueToParse: string): string => {
   return valueToParse.replace(/[^0-9]*/g, "");
}

export const firstLetterCapitalized = (valueToParse: string): string => {
   return valueToParse.charAt(0).toUpperCase() + valueToParse.slice(1)
}

export const personalIdParser = (valueToParse: string): string => {
   return valueToParse.toUpperCase().replace(/\s/g, "");
}
